import { useContext, useLayoutEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { useHeap } from '../../hooks/useHeap';
import { ConfigurationContext } from '../../providers/ConfigurationProvider';
import PageNotFound from '../pageNotFound/PageNotFound';
import { getRoutes } from './Route.utils';

import RouteWithSubRoutes from './RouteWithSubRoutes';

export default function RouteConfig() {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const config = useContext(ConfigurationContext);
  useHeap(config);
  return (
    <div className="flex sm:w-full 2xl:w-1440px items-center justify-center">
      <Switch>
        {getRoutes(config?.ADMIN_ROLES ?? []).map((route, i) => (
          <RouteWithSubRoutes key={i} {...route} />
        ))}
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    </div>
  );
}
